import React from 'react';
import Plus from '@crehana/icons/dist/outline/Plus';
import Minus from '@crehana/icons/dist/outline/Minus';
import styled from 'styled-components';

const MenuIconContainer = styled.div<{ size: number }>`
  max-width: ${({ size }) => size}px;
  max-height: ${({ size }) => size}px;

  .opened {
    animation: rotate-90 0.2s ease-in-out;
  }

  .closed {
    animation: rotate-90 0.2s ease-in-out reverse;
  }

  /**
  * ----------------------------------------
  * animation flip-horizontal-bottom
  * ----------------------------------------
  */
  @keyframes rotate-90 {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(90deg);
    }
  }
`;

interface MenuIconProps {
  opened: boolean;
}

const MenuIcon: React.FC<MenuIconProps> = ({ opened }) => {
  const iconSize = 16;

  return (
    <MenuIconContainer size={iconSize}>
      {opened ? (
        <Minus
          ignoreColor
          className="fill-current min-w-16 text-base-main opened"
          size={iconSize}
        />
      ) : (
        <Plus
          ignoreColor
          className="fill-current min-w-16 text-base-main closed"
          size={iconSize}
        />
      )}
    </MenuIconContainer>
  );
};

export default MenuIcon;
